import React, { PureComponent } from 'react';
import { View } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import Text , { H3, H1} from '@dbk/ui-text';
import {
  NavigationListItem,
  NavigationListItemHeader,
  NavigationListItemContent,
  NavigationListItemFooter,
} from '@dbk/ui-list';
import reject from 'lodash/reject';
import { FormattedNumber } from '@dbk/ui-format'
import Spinner from '@dbk/ui-spinner';
import { ShortDate } from '@dbk/ui-dates';
import { Close } from '@dbk/ui-icons';
import SearchWithoutCircleIcon from '../../../common/components/icons/search-without-circle';
import Modal from '@dbk/ui-modal';
import Search from '@dbk/ui-search';
import { ScrollView } from '@dbk/ui-react-utils';
import ScrollTopOnMount from '../../../components/common/scroll-top-on-mount'
import {
  centerSpinner,
  scrollBarStyle,
  modalstyle,
  searchIconStyle,
  titleStyle,
  emptyStateWrapper,
  emptyStateText,
  accountBalanceHeaderStyle,
  accountBalanceHeaderRowStyle,
  accountHeaderTextStyle,
  balanceHeaderTextStyle,
} from './debit-account-list.styles';
import { ROUTES, PALETTE, KEY_CODE , EBANKINGWEBUK , RM_REGION_UK} from '../../../constants';
import envConfig  from '../../../../../dbk-web/db-env-build'
import labelForPFid from '../../../utils/portfolio-number-aria-label';

const { PAYMENT } = ROUTES
const ICON_WDTH_HT = 23;


const alignRightStyle = {flex: 1, alignItems: 'flex-end'};
const footerTextContainerStyle = {
  display: 'block',
  flex: 'none',
  maxWidth: '100%',
};
const footerLabelStyle = {
  color: PALETTE.secondaryText,
  display: 'inline',
  flex: 'none',
  maxWidth: 'none',
};
const footerValueStyle = {
  color: PALETTE.secondaryActive,
  display: 'inline',
  flex: 'none',
  maxWidth: 'none',
};
const asOfPrefixStyle = {
  color: PALETTE.secondaryText,
};

class DebitAccountList extends PureComponent {
  state = {
    enableSearch: false,
    searchResult: [],
    searchText: '',
    isSearching: false,
  }

  componentWillUnmount(){
    if(this.props.payments.selectedBeneficiaryBank || this.props.payments.selectedCreditAcnt ||
       this.props.payments.selectedDebitAcnt){
       this.props.replace({ pathname: ROUTES.PAYMENT.NEW_DOMESTIC });
    }
  }


  onSearch = () => {
    let text = this.state.searchText
    const isValid = text && text.trim().length>2
    if (!isValid) return this.setState({ enableSearch: false });
    text = text.trim()
    if (!text) {
      this.setState({ enableSearch: false })
    } else {
      this.setState({ isSearching: true })
      setTimeout(() => {
        const {
          selectCreditAccFlag,
          creditAcList,
          debtAcList,
        } = this.props.payments
        const list = selectCreditAccFlag ? creditAcList : debtAcList
        const searchResult = this.filterResults(text, list)
        this.setState({
          isSearching: false,
          searchResult,
          enableSearch: true,
        })
      }, 100);
    }
  }
  handleSearchKeyDown = event => {
    if (event.keyCode === KEY_CODE.ENTER_KEY) {
      event.preventDefault();
      this.onSearch();
    }
  }
  filterResults = (text, list) => {
    if (!list || !list.length) return []
    const callback = obj =>
      obj.pfId.includes(text) ||
      (`${obj.accNo}`).includes(text) ||
      obj.accName.toLowerCase().includes(text.toLowerCase())
    return list.filter(callback);
  }
  closeSearchModal = () => {
    this.props.payments.setInitializeTxFails(false);
    this.props.changePage(PAYMENT.DASHBOARD);
  }
  handleRowPress = (row, e)=> {
    const {
      payments: {
        assignDefaultCurrency,
        setSelectedDebitAcnt,
        selectCreditAccFlag,
        setSelectCreditAccFlag,
        setSelectedCreditAcnt,
        paymentType,
        resetForm,
        isModifyDebitAcnt,
        setModifyDebitAcntFlag,
      },
      changePage,
    } = this.props;
    if((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){ 
      if(selectCreditAccFlag && paymentType.includes('internal')){
        // when internal payment set as payee
        setSelectedCreditAcnt(row);
        setSelectCreditAccFlag(false);
      } else {
        // resetForm();
        setSelectedDebitAcnt(row);
        !isModifyDebitAcnt && assignDefaultCurrency();
        setModifyDebitAcntFlag(false);
      }
      changePage(PAYMENT.NEW_DOMESTIC);
    }
  }
  // todo: generic parse function
  toNumber = amount => typeof amount === 'number' ?
    amount : Number(amount.replace(/[^0-9.]/g,''))

  render() {
    const {
      i18n: { messages },
      payments: {
        isInitializingTx,
        initializeTxFails,
        creditAcList,
        debtAcList,
        selectCreditAccFlag,
        paymentType,
        selectedCreditAcnt,
        selectedDebitAcnt,
        setDebitAccountFlow
      }
    } = this.props;
    if (isInitializingTx && !initializeTxFails) return (
      <View style={centerSpinner}><Spinner size="large"/></View>
    );
    if (!isInitializingTx && initializeTxFails) {
      return (
        <Modal
          isActive
          style={modalstyle}
          onClose={() => this.closeSearchModal()}
          content={
            <div className="columns small-12 small-centered margin20">
              <div className="row" tabIndex={0} role="alert" aria-label={messages['app.payments.failToConnect']}>
                <Text size={"large"}>{messages['app.payments.failToConnect']}</Text>
              </div>
            </div>
          } />
      )
    }
    const {
      isSearching,
      enableSearch,
      searchResult,
    } = this.state;
    let listData = debtAcList
    if (enableSearch) {
      listData = [...searchResult]
    } else if (selectCreditAccFlag) {
      listData = [...creditAcList];
    }

    if( paymentType.includes('internal') && !enableSearch) {
      // selecting FromAccount flow
     if(selectedCreditAcnt && setDebitAccountFlow) {
       listData = reject(creditAcList, selectedCreditAcnt);
     }
     // selecting ToAccount Flow
     else if(selectedDebitAcnt && !setDebitAccountFlow) {
       listData = reject(creditAcList, selectedDebitAcnt);
     }else{
         listData = creditAcList;
     }
   }

    let pageTitle
    if (selectCreditAccFlag && paymentType.includes('internal')) {
      pageTitle = messages['app.payments.selectCreditAcc']
    } else {
      pageTitle = messages['app.payment.pageTitle.debitAccount']
    }
    const portfolioText = messages['app.payments.portfolio.text']
    const asOfDatePrefix = messages['app.payments.asOfDate']
    const showNoResultsState = enableSearch && !isSearching && (!listData || !listData.length)
    return (
      <div className="payment-page debit-account-list payment-page__destination">
        <ScrollTopOnMount style={titleStyle}/>
        <div className="row title" >
          <H1 id="title_selectDebitAccount_debitAccountList_test" tabIndex={0}>{pageTitle}</H1>
          <View style={{flexDirection:'row'}}>
            <div className='search--container' style={{ width: '30%' }}>
              <Search
                value={this.state.searchText}
                size="large"
                iconLeft={<SearchWithoutCircleIcon style = {searchIconStyle} width={ICON_WDTH_HT} height ={ICON_WDTH_HT} />}
                iconRight={Close}
                placeholder={messages['app.payments.debit.account.search']}
                onChange={searchText => this.setState({ searchText })}
                onKeyDown={this.handleSearchKeyDown}
                testID="input-searchId"
                id="input-searchId"
              />
            </div>
          </View>
        </div>
        <div className="row accBalHdr" style={accountBalanceHeaderStyle}>
          <View style={accountBalanceHeaderRowStyle}>
            <Text secondary size="normal" tabIndex={0} style={accountHeaderTextStyle}>{messages['app.payment.account']}</Text>
            <Text secondary size="normal" tabIndex={0} style={balanceHeaderTextStyle}>{messages['app.payment.balanceCcy']}</Text>
          </View>
          {showNoResultsState ?
          <div className="dbtAcntLst" role="status" aria-live="polite">
            <div style={emptyStateWrapper}>
              <Text style={emptyStateText} tabIndex={0}>{messages['app.reports.noRecords']}</Text>
            </div>
          </div> :
          listData && listData.length ?
          <div className="dbtAcntLst">
            {isSearching ?
            <View style={centerSpinner}><Spinner size="large"/></View> :
            <ScrollView style={scrollBarStyle} accessible={false}>
              {listData.map(row =>
              <div className="debit-account-list__item" onKeyDown={(e) => this.handleRowPress(row, e)} tabIndex={-1}>
              <NavigationListItem color="#A4C8E1" className={"ben-to-container"} testID={"list_selectDebitAccount_debitAccountList_test"} hasArrow={true} key={row.accNo} inverse onClick={() => this.handleRowPress(row)} tabIndex={-1}>
                <NavigationListItemHeader tabIndex={row.bpName?"0":"-1"}>
                  <Text className={"ben-header-name"}>{row.bpName}</Text>
                  <NavigationListItemContent>
                    <span>{row.currency+' '}
                    <FormattedNumber
                      value={this.toNumber(row.accBalance)}
                      formatStyle="currency"
                      // style="currency" // todo: one day dbk-ui fix EUR280,747.34 no space, uncomment this
                      currencyDisplay="code"
                      currency={row.currency}
                    />
                    </span>
                  </NavigationListItemContent>
                </NavigationListItemHeader>
                <NavigationListItemFooter color={PALETTE.secondaryActive} testID={"text_selectDebitAccount_number_debitAccountList_test"} tabIndex={(row.accName)?"0":"-1"}>
                  <Text plain style={footerTextContainerStyle}>
                    <Text plain style={footerLabelStyle}>{messages['app.payment.account.name']+': '}</Text>
                    <Text plain style={footerValueStyle}>{row.accName}</Text>
                  </Text>
                </NavigationListItemFooter>
                  <View style={alignRightStyle}>
                   {(envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK)?  <Text plain tabIndex={0}>
                    {messages['app.payment.asOfToday']}
                   </Text> : 
                   <Text plain style={alignRightStyle} tabIndex={0}>
                        <Text plain style={asOfPrefixStyle}>{asOfDatePrefix+'  '}</Text>
                        <Text plain style={footerValueStyle}><ShortDate value={new Date(row.asOfDate)} /></Text>
                    </Text>}
                  </View>
                  <NavigationListItemFooter
                    color={PALETTE.secondaryActive}
                    tabIndex={row.ibanNo ? "0" : "-1"}
                    style={row.ibanNo ? undefined : { display: 'none' }}>
                    <Text plain style={footerTextContainerStyle}>
                      <Text plain style={footerLabelStyle}>{messages['app.payment.psd2.ibanNo']+': '}</Text>
                      <Text plain style={footerValueStyle}>{row.ibanNo}</Text>
                    </Text>
                  </NavigationListItemFooter>
                <NavigationListItemFooter color={PALETTE.secondaryActive} tabIndex={row.pfId?"0":"-1"} aria-label={portfolioText+ labelForPFid(row.pfId)}>
                  <Text plain style={footerTextContainerStyle}>
                    <Text plain style={footerLabelStyle}>{`${portfolioText}: `}</Text>
                    <Text plain style={footerValueStyle}>{row.pfId}</Text>
                  </Text>
                </NavigationListItemFooter>
              </NavigationListItem>
              </div>
              )}
            </ScrollView>}
          </div> :
          null}
          </div>
      </div>
    );
  }
}

export default createContainer({
   $queries: {
    replace: { $call : 'ui.history.replace'},
    changePage: { $call: 'ui.history.push' },
     i18n: { messages: true },
    payments:{
      debtAcList:true,
      isDebitAcnt:true,
      isInitializingTx: true,
      initializeTxFails: true,
      selectedDebitAcnt:true,
      setInitializeTxFails: { $set: 'initializeTxFails' },
      setSelectedDebitAcnt:{ $set: 'selectedDebitAcnt' },
      assignDefaultCurrency : { $call: 'assignDefaultCurrency'},
      paymentType: true,
      selectCreditAccFlag: true,
      setSelectCreditAccFlag: { $set: 'selectCreditAccFlag' },
      creditAcList: true,
      selectedCreditAcnt:true,
      setSelectedCreditAcnt: { $set: 'selectedCreditAcnt'},
      resetForm: { $call: 'resetForm' },
      isModifyDebitAcnt: true,
      setModifyDebitAcntFlag: { $set: 'isModifyDebitAcnt'},
      selectedBeneficiaryBank: true,
      setDebitAccountFlow: true
    }
  },
})(DebitAccountList);
